import { defineMessages } from "react-intl";

export const messages = defineMessages({
  enterCode: {
    defaultMessage: "Enter code",
    id: "SGdcJD",
  },
  enterUsage: {
    defaultMessage: "Enter usage",
    id: "qPSWmL",
  },
  codeExists: {
    id: "dHAwu8",
    defaultMessage: "Code already exists",
  },
});
